import { TvChannel } from '@tivio/types'
import { createContext } from 'react'


export const ChannelContext = createContext<TvChannel | undefined | null>(undefined)
